var getGlobal = function getGlobal() {
  if (typeof self !== "undefined") {
    return self;
  }

  if (typeof global !== "undefined") {
    return global;
  }

  if (typeof window !== "undefined") {
    return window;
  }

  return {};
};

var globals = getGlobal(); // Adyen SDK

var adyen = require("./adyen.encrypt.nodom.js");

globals.adyen = adyen; // Ingenico Connect SDK

if (!globals.forge) {
  var forge = require("./forge.min.js");

  globals.forge = forge;
}


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/vendor_modules/vendor_modules.js